import axios, { AxiosRequestConfig } from 'axios';
import { PagedResponse } from '../types';

const USER_VERIFICATION_LOG_URL = '/v2/user-verification-logs';

class UserVerificationLogService {
  static findByFilter(params: string, config?: AxiosRequestConfig): Promise<PagedResponse<unknown>> {
    return axios.get(`${USER_VERIFICATION_LOG_URL}${params}`, config);
  }
}

export { UserVerificationLogService };
